<!--

SELECIONA PLANOS PARA PAGAMENTO DO APP NFE

-->

<template>
  <div class="registro">
    <header class="shared-header">
      <div class="col-md-12 col-12 text-center">
        <a class="valign" href="#">
          <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png">
        </a>
      </div>
    </header>
    <transition name="fade" mode="out-in">
      <div class="container" v-if="!sucesso" style="margin-bottom: 100px">

        <div v-if="isEndTrial">
          <div class="activation text-center mb-2">
            <h3>Seu período de testes expirou!</h3>
          </div>
          <div class="activation text-center mb-2">
            <h3>Selecione agora um plano para continuar a utilizar o Nota Brasil</h3>
          </div>
        </div>

        <div id="NFE">
          <div class="row text-center">
            <div class="w-100 title"> Planos Disponíveis </div>
          </div>
          <div class="activation">
            <div class="row justify-content-center">
              <div class="col-md-4 col-12 justify-content-center" v-for="(plano, index) in planoNFe" :key="index">
                <div class="app h-100">
                  <div class="text-center">
                    <div class="justify-content-center title"> {{ plano.nome }} </div>
                    <div class="row price-info align-items-center text-center">
                      <span class="w-100">
                        R$
                        <span class="price">{{ plano.valor | formatValue(2) }} </span>
                        /mês
                      </span>
                      <span class="w-100 periodo-text"> {{ plano.total_text }} </span>
                    </div>
                    <div class="info">
                      <p v-for="(descricao, index) in plano.descricao" :key="index"> {{ descricao }} </p>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-12">
                      <warnings class="text-center"
                        :messages="['Este plano foi reajustado pela inflação acumulada dos últimos 48 meses.']">
                      </warnings>
                    </div>
                  </div>
                  <div class="row justify-content-center w-100">
                    <button type="button" class="app-button w-50" @click="handleAssinar(plano.app, plano.plano)">
                      Assinar </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="activation row justify-content-center text-center">
          <h3> Em caso de dúvidas, entre em contato com nosso atendimento via chat </h3>
          <h5> Nossos planos incluem suporte via CHAT de segunda à sexta das 08:30 às 17:30 </h5>
        </div>

        <div class="container-dados-faturamento">
          <h3>Informe seus dados para nota fiscal</h3>
          <div class="default-container mt-4">
            <div class="my-3">
              <label class="lbl-edit pb-1" for="">Tipo de Pessoa</label>
              <br>
              <input type="radio" v-model="dadosFaturamento.tppessoa" name="tppessoa" id="" value="F">
              <label class="lbl" for="">Pessoa Fisica</label>
              <input type="radio" v-model="dadosFaturamento.tppessoa" name="tppessoa" id="" value="J">
              <label class="lbl" for="">Pesso Juridica</label>
            </div>
            <div class="row">
              <form-field ref="nome" v-model="dadosFaturamento.nome" type="text" col="6" label="Nome" name="nome"
                :v-errors="errors" v-validate="{ required: true, max: 60, cpf: false }"></form-field>
            </div>
            <div class="row" v-if="dadosFaturamento.tppessoa == 'J'">
              <form-field ref="cnpj" v-model="dadosFaturamento.cnpj" type="cnpj" col="3" label="CNPJ" name="cnpj"
                :v-errors="errors" v-validate="{ cnpj: true, cpf: false }"></form-field>
            </div>
            <div class="row" v-if="dadosFaturamento.tppessoa == 'F'">
              <form-field ref="cpf" v-model="dadosFaturamento.cpf" type="number" col="3" label="CPF" name="cpf"
                :v-errors="errors" v-validate="{ cpf: true, cnpj: false }"></form-field>
            </div>
            <div class="row" v-if="dadosFaturamento">
              <form-field v-model="dadosFaturamento.cep" type="cep" col="3" label="Cep" name="cep" :v-errors="errors"
                v-validate="{ required: true }" @update="updateCep"></form-field>
            </div>
            <div class="row" v-if="dadosFaturamento">
              <form-field v-model="dadosFaturamento.endereco" type="text" col="4" label="Endereço" name="ende"
                :v-errors="errors" v-validate="{ required: true, max: 60 }"></form-field>
              <form-field v-model="dadosFaturamento.nr" type="text" col="2" label="Número" name="endenr"
                :v-errors="errors" v-validate="{ required: true, max: 20 }"></form-field>
              <form-field v-model="dadosFaturamento.complemento" type="text" col="4" label="Complemento" name="endecomp"
                :v-errors="errors" v-validate="{ max: 40 }"></form-field>
            </div>

            <div class="row" v-if="dadosFaturamento">
              <form-field v-model="dadosFaturamento.bairro" type="text" col="4" label="Bairro" name="bairro"
                :v-errors="errors" v-validate="{ required: true, max: 60 }"></form-field>
            </div>
            <div class="row" v-if="dadosFaturamento">
              <form-field v-model="dadosFaturamento.uf" type="select2" col="4" label="Estado" name="uf"
                :v-errors="errors" v-validate="{ required: true }" :select2="{ entity: 'estado', minlength: 0 }">
              </form-field>
            </div>
            <div class="row" v-if="dadosFaturamento">
              <form-field v-model="dadosFaturamento.codmun" type="select2" col="4" label="Cidade" name="codmun"
                :v-errors="errors" v-validate="{ required: true }"
                :select2="{ entity: 'mun/uf/' + dadosFaturamento.uf, minlength: 2 }"></form-field>
            </div>
            <div class="row" v-if="dadosFaturamento">
              <form-field v-model="dadosFaturamento.fone" type="fone" col="4" label="Telefone" name="fone"
                :v-errors="errors" v-validate="{ max: 15, required: true }"></form-field>
            </div>
          </div>
        </div>

      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <div v-if="sucesso">
        <div class="activation text-center">
          <h2 class="title">Sucesso!</h2>
          <h3>Estamos aguardando a confirmação do seu pagamento.</h3>
        </div>
        <div class="row justify-content-center w-100">
          <button type="button" class="app-button" @click="handleInicio"> Retornar ao Nota Brasil </button>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>

import { apiORDSapp } from '../shared/api-functions'
import { SysVars } from '../main'
import { isValidPostalCode } from '../shared/utils'

export default {
  props: {
    saldoPlanoAtual: { Type: Number },
    planoAtual: { Type: String },
  },

  data() {
    return {
      errmessages: null,
      title: '',
      sucesso: false,

      dadosFaturamento: {},
      hasValid: false,
      currentPlan: null,
      periodo: 1,

      periodos: [
        { nome: 'Mensal', selected: false },
        { nome: 'Trimestral', selected: true },
      ],

      planoNFe: [
        {
          app: 'NFE',
          plano: 'BTRIM',
          nome: 'Básico Trimestral',
          valor: 49.90,
          total_text: 'R$ 149,70 por Trimestre',
          descricao: [
            '1 CNPJ',
            'Emissão de NF-e de Produtos',
            'Emissão de NFC-e de Consumidor',
            'Suporte via CHAT',
          ],
          valor_adicional: 0,
          desconto_troca_plano: 0,
          selected: false,
        },
      ],

    }
  },

  computed: {

    isEndTrial: function () {
      return SysVars.appEndTrial
    },


  },


  methods: {
    loadParams() {
      let params = SysVars.planosParams;
      this.currentPlan = null;
      this.dadosFaturamento = null;

      if (params) {
        this.currentPlan = params.planoAtual;
        this.dadosFaturamento = params.dadosFaturamento;
      }

      if (!this.dadosFaturamento) {
        this.dadosFaturamento = {
          tppessoa: 'J',
          nome: null,
          cnpj: '',
          cpf: '',
          cep: null,
          endereco: null,
          bairro: null,
          uf: null,
          codmun: null,
          complemento: null,
          nr: null,
          fone: null,
        };
      }

      if (!this.dadosFaturamento.tppessoa) {
        this.dadosFaturamento.tppessoa = 'J';
      }

    },

    handleSelectPeriodo(idx) {
      this.periodos[this.periodo].selected = false
      this.periodo = idx
      this.periodos[this.periodo].selected = true
    },

    handleLogin() {
      this.$router.push('/login')
    },

    handleInicio() {
      window.location.href = '/'
    },

    async apiPost() {

      // this.$appLoading(true)
      // var params = '?email=' + this.email + '&id=' + this.id
      // const ativacao = await apiORDSapp(this, 'assinatura/ativar' + params, 'get', null)
      // this.$appLoading(false)
      // if (ativacao.errmessages) {
      //   this.errmessages = login.errmessages
      //   return
      // } else {
      //   this.title = 'Sua conta foi ativada. Você será redirecionado à tela de login.'
      //   this.showLogin = true
      // }

    },

    async handleAssinar(app, plano) {

      await this.handleValidadados();
      if (this.hasValid) {
        let objeto = {}
        objeto.plano = plano;
        objeto.codplan = plano;
        objeto.app = app;
        objeto.dadosFaturamento = this.dadosFaturamento
        if (this.dadosFaturamento.tppessoa == 'J')
          objeto.dadosFaturamento.cnpj = this.dadosFaturamento.cnpj
        else
          objeto.dadosFaturamento.cpf = this.dadosFaturamento.cpf

        this.$appLoading(true);
        let sendData = objeto

        const pagseguro = await apiORDSapp(this, 'sessao/pagseguro/', 'post', sendData)
        this.$appLoading(false)

        let self = this
        console.log(pagseguro)
        window.open(pagseguro.link, "_blank");
        self.$appLoading(false)
        var resultOptions = {};
        resultOptions.updateDataTable = false;
        self.sucesso = true;

        this.planSubscriptionSteps = [1]


      }
    },
    updateCep() {
      //CARREGA INFORMACOES DO CEP
      this.dadosFaturamento.endereco = SysVars.endereco.logradouro;
      this.dadosFaturamento.bairro = SysVars.endereco.bairro;
      this.dadosFaturamento.codmun = SysVars.endereco.ibge;
      this.dadosFaturamento.uf = SysVars.endereco.uf;
    },
    async handleValidadados() {
      await this.$validator.validateAll().then(isValid => {
        this.hasValid = false
        if (!isValid || (!this.dadosFaturamento.cnpj && !this.dadosFaturamento.cpf)) {
          this.$refs.nome.focus()
          this.$erpToastError((!this.dadosFaturamento.cnpj && !this.dadosFaturamento.cpf) ? 'Por favor, verifique se o campo de CNPJ ou CPF e os demais campos estão preenchidos' : 'Por favor, corrija os campos em destaque para continuar');
        } else if (!isValid || (!isValidPostalCode(this.dadosFaturamento.cep))) {
          this.$refs.nome.focus()
          this.$erpToastError((!isValidPostalCode(this.dadosFaturamento.cep)) ? 'Por favor, verifique se o campo CEP e os demais campos estão preenchidos corretamente' : 'Por favor, corrija os campos em destaque para continuar');

        } else {
          this.hasValid = true
        }
      })
    },

  },

  components: {

  },

  mounted() {
    this.loadParams();

    for (var x = 0; x < this.planoNFe.length; x++) {
      if (this.planoNFe[x].plano != this.planoAtual)
        this.planoNFe[x].desconto_troca_plano = this.saldoPlanoAtual
    }

  },

  created() {

  }

}

</script>

<style>
.shared-header {
  display: block;
  padding: 15px 0;
  margin-top: 15px;
}

.shared-header .valign {
  line-height: 30px;
  vertical-align: middle;
}

.activation {
  margin-top: 64px;
}

.activation h3 {
  margin-bottom: 32px;
  font-size: 30.4px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.58;
  letter-spacing: -.5px;
  color: #222;
  margin-top: 64px;
}

.activation h5 {
  margin-top: 30px;
  margin-bottom: 64px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.58;
  letter-spacing: -.5px;
  color: #222;
}

.activation-button {
  border: 2px solid #267da5 !important;
  /* border-radius: 3px!important; */
  border-radius: 0.70rem;
  margin-top: 50px;
  cursor: pointer;
  width: 200px !important;
  height: 45px !important;
  background-color: #267da5 !important;
  color: #fff !important;
  font-size: 15px !important;
}

.registro {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  /* display: table; */
  display: block;
  transition: opacity .3s ease;
  overflow: auto;
}

.app-button {
  border: 2px solid #ffe871 !important;
  border-radius: 0.70rem;
  cursor: pointer;
  height: 45px !important;
  background-color: #ffe871 !important;
  color: black !important;
  font-size: 16px !important;
  font-weight: 600;
}

.app {
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #d3d2d2;
  padding: 15px;
  font-size: 22px;
  letter-spacing: -0.15px;
  line-height: 24px;
  transition: all .2s;
  box-shadow: 0 5px 15px 0 rgba(82, 95, 127, .15);
}

.app:hover {
  border: 1px solid #22f387;
  cursor: pointer;
}

.active {
  border: 3px solid #22f387;
}

.app .title {
  color: #222;
  font-size: 22px;
  letter-spacing: -0.15px;
  line-height: 27px;
  display: flex;
  flex: 1;
  transition: all .2s;
  margin: 0;
  text-align: center;
}

.app .margin {
  margin-bottom: 32px;
}

.app .info {
  margin: 30px 0 50px;
}

.app .price-info {
  margin: 30px 0 50px;
}

.app p {
  color: #757575;
  font-family: Open Sans, sans-serif;
  font-size: 16px;
  line-height: 19px;
  flex: 1;
}


.price {
  color: #1cc925;
  font-size: 36px;
  font-weight: 700;
  line-height: normal;
}

.title-price {
  display: inline-block;
  font-size: 18px;
  color: #151414;
  text-align: center;
  font-weight: 600;
}

.app-info h5 {
  margin: 10px 0 20px;
  font-weight: 300;
  line-height: 1.58;
  letter-spacing: -.5px;
  color: #222;
}

.title {
  color: #222;
  font-size: 36px;
  font-weight: 600;
  letter-spacing: -1.13px;
  line-height: 44px;
  margin: 90px 0 0;
}

.box-clientes {
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* border: 1px solid #E0E0E0; */
  /* border-radius: 15px; */
  padding: 15px;
  transition: all .2s;
  box-shadow: 0 5px 15px 0 #3a405048
}






.recursos-container {
  margin-top: 10px;
  transition: all .2s;
  box-shadow: 0 5px 15px 0 #3a405048;
  border: 1px solid #d3d2d2;
  /* border-radius: 15px; */
}

.recursos-container th {
  padding: 20px 30px 5px;
}

.recursos-container td {
  padding: 20px 30px;
  border: 1px solid #f4f5f7;
}

.recursos-container table thead {
  /* background-color: #fafbfc; */
}

.recursos-container .feature-check {
  width: 215px;
}

.recursos-container .title {
  color: #222;
  font-size: 18px;
  font-weight: 400;
  margin: 0;
}

.primary {
  background-color: #1cc925;
}

.periodo-info {
  font-size: 22px;
  letter-spacing: -0.15px;
  line-height: 24px;
}

.periodo-text {
  color: #1cc925;
  font-weight: 700;
  line-height: normal;
}
</style>






// WEBPACK FOOTER //
// src/forms/app-planos-nfe.vue